export default "__VITE_ASSET__BVr0dtV0__"